
export function encryptData(data) {
    const base64Encode = (data) => {
      return btoa(data);
    };
    var encodedId = base64Encode(data);
  
    for(var i = 0; i < 5; i++){
      encodedId  = base64Encode(encodedId);
    }
    return encodedId;
}